export default __webpack_public_path__ + "static/media/April2021.6ad76dd5.png";